"use client";

import { useState } from "react";
import { SlidersHorizontal, FileCheck, Printer, Truck, ArrowRight, ArrowLeft, Check, Phone, Truck as Van, Route } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
const steps = [{
  id: 1,
  title: "Call Our Dispatch",
  description: "Contact our 24/7 Leeds emergency line",
  icon: Phone
}, {
  id: 2,
  title: "Technician Dispatched",
  description: "Rapid response within 30-60 minutes",
  icon: Van
}, {
  id: 3,
  title: "Back On The Road",
  description: "Expert fitting and safety check complete",
  icon: Route
}];
export default function LeParcoursBoxify() {
  const [activeStep, setActiveStep] = useState(1);
  const handleNext = () => {
    if (activeStep < steps.length) {
      setActiveStep(prev => prev + 1);
    }
  };
  const handlePrev = () => {
    if (activeStep > 1) {
      setActiveStep(prev => prev - 1);
    }
  };
  const progressValue = (activeStep - 1) / (steps.length - 1) * 100;
  return <section data-section-id="224456" id="3-simple-steps-to-safety" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-bold mb-4 tracking-tighter uppercase">
            3 Simple Steps to Safety
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Our streamlined process ensures you're never stranded for long. From your first call to the final torque check, we handle everything.
          </p>
        </div>

        <div className="relative mt-12 mb-16">
          {}
          <div className="absolute top-8 left-[12.5%] w-[75%] -translate-y-1/2 hidden sm:block">
            <Progress value={progressValue} className="h-1 bg-muted" />
          </div>

          {}
          <div className="absolute left-8 top-8 bottom-8 w-1 -translate-x-1/2 sm:hidden">
            <Progress value={progressValue} className="w-1 h-full flex-col bg-muted" />
          </div>

          <div className="flex flex-col sm:flex-row justify-between relative z-10 gap-8 sm:gap-0">
            {steps.map((step, i) => {
            const isCompleted = activeStep > step.id;
            const isActive = activeStep === step.id;
            const isPending = activeStep < step.id;
            const Icon = isCompleted ? Check : step.icon;
            return <div key={step.id} data-index={i} className="flex sm:flex-col items-center sm:text-center sm:w-1/3 relative group cursor-pointer" onClick={() => setActiveStep(step.id)}>
                  {}
                  {i !== steps.length - 1 && <div className="absolute left-8 top-16 bottom-[-2rem] w-px bg-border sm:hidden -translate-x-1/2" />}
                  {i !== steps.length - 1 && isCompleted && <div className="absolute left-8 top-16 bottom-[-2rem] w-px bg-primary sm:hidden -translate-x-1/2 transition-all duration-500" />}

                  <div className={`
                      w-16 h-16 rounded-full flex items-center justify-center border-2 shrink-0 transition-all duration-500 ease-in-out
                      ${isActive ? "bg-card border-primary text-primary shadow-lg scale-110" : isCompleted ? "bg-primary border-primary text-primary-foreground" : "bg-card border-border text-muted-foreground"}
                    `}>
                    <Icon className={`w-7 h-7 ${isActive ? "animate-pulse" : ""}`} />
                  </div>

                  <div className="ml-6 sm:ml-0 sm:mt-6">
                    <h3 className={`font-default text-lg font-bold mb-1 transition-colors duration-300 uppercase tracking-tight ${isActive || isCompleted ? "text-foreground" : "text-muted-foreground"}`}>
                      {step.id}. {step.title}
                    </h3>
                    <p className="text-sm text-muted-foreground max-w-[200px] mx-auto font-default">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className="flex justify-center items-center gap-4 mt-12 pt-8 border-t border-border">
          <Button variant="outline" onClick={handlePrev} disabled={activeStep === 1} className="w-32 rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all">
            <ArrowLeft className="mr-2 w-4 h-4" />
            Back
          </Button>
          <span className="text-sm text-muted-foreground font-mono w-24 text-center">
            STEP {activeStep} / {steps.length}
          </span>
          <Button onClick={handleNext} disabled={activeStep === steps.length} className="w-32 rounded-full bg-primary text-primary-foreground shadow-md hover:shadow-primary/20 transition-all">
            Next
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>;
}